import request from '@/utils/request'

// 获取配置信息
export const getConfigInfoApi = (settingKey) => request({
  url: '/setting/getSettingByKey',
  method: 'get',
  params: { settingKey }
})
// 获取应用列表
export const getAppListApi = () => request({
  url: '/bd/operation/getUserOperation',
  method: 'get',
  params: { platformType: 2 }
})
// 获取用户信息
export const getUserInfoApi = () => request({
  url: '/bd/user/userInfo',
  method: 'get'
})
